import { Button } from 'antd';
import { ReactComponent as Plus } from '../../../res/svg/plus-cc.svg';
import './MapAddMultipleGeometriesButton.less'
import { useAppDispatch, useAppSelector } from '../../../store/hooks/hooks';
import { addMultipleFeaturesSelected } from '../../../store/slice/mapLayersSlice';

function MapAddMultipleGeometriesButton() {
  const addingMultipleFeatures = useAppSelector(state => state.mapLayers.addingMultipleFeatures);
  const secondPoint = useAppSelector(state => state.mapLayers.secondPoint);
  const preSelectedFeatures = useAppSelector(state => state.mapLayers.preSelectedFeatures);
  const loading = useAppSelector(state => state.mapLayers.loading);
  const dispatch = useAppDispatch();
  if(!addingMultipleFeatures || !secondPoint || !preSelectedFeatures.length){
    return null;
  }

  return (
    <div className='at-map-add-multiple-geometries-button__container'>
      <Button
        loading={loading}
        className={'at-map-add-multiple-geometries-button__button'}
        size='large'
        shape='round'
        onClick={() => dispatch(addMultipleFeaturesSelected())}
        type={'ghost'}
        icon={<Plus />}
      >
        Agregar geometrías a la tarea
      </Button>
    </div>
  );
}

export default MapAddMultipleGeometriesButton;
